import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { getCheckoutStatus } from '@/lib/api';

export default function PaymentSuccess() {
    const [params] = useSearchParams();
    const sid = params.get('session_id');
    const [status, setStatus] = useState({ state: 'checking', data: null });

    useEffect(() => {
        if (!sid) { setStatus({ state: 'error', data: null }); return; }
        let attempts = 0;
        const poll = async () => {
            attempts++;
            try {
                const data = await getCheckoutStatus(sid);
                if (data.payment_status === 'paid') { setStatus({ state: 'paid', data }); return; }
                if (data.status === 'expired') { setStatus({ state: 'expired', data }); return; }
                if (attempts < 6) setTimeout(poll, 2000);
                else setStatus({ state: 'pending', data });
            } catch {
                if (attempts < 6) setTimeout(poll, 2000);
                else setStatus({ state: 'error', data: null });
            }
        };
        poll();
    }, [sid]);

    return (
        <div data-testid="payment-success-page" className="pt-40 pb-32 min-h-[80vh] flex items-center">
            <div className="max-w-2xl mx-auto px-6 md:px-12 text-center">
                {status.state === 'checking' && (
                    <>
                        <span className="overline" style={{ color: 'var(--ochre)' }}>Confirming</span>
                        <h1 className="serif text-5xl md:text-7xl mt-6 leading-[1]" style={{ letterSpacing: '-0.02em' }}>One moment</h1>
                        <p className="serif-italic text-xl mt-6" style={{ color: 'var(--ink-2)' }}>Verifying your payment with our partners.</p>
                    </>
                )}
                {status.state === 'paid' && (
                    <div data-testid="payment-confirmed">
                        <span className="overline" style={{ color: 'var(--ochre)' }}>Confirmed</span>
                        <h1 className="serif text-5xl md:text-7xl mt-6 leading-[1]" style={{ letterSpacing: '-0.02em' }}>Thank you.</h1>
                        <p className="mt-8 text-lg leading-relaxed" style={{ color: 'var(--ink-2)' }}>
                            Your {status.data.metadata?.payment_type === 'deposit' ? 'reserve' : 'acquisition'} of <em className="serif-italic">{status.data.metadata?.artwork_title}</em> has been confirmed. A receipt has been logged and a member of the Maison Touré team will be in touch within 24 hours to coordinate next steps.
                        </p>
                        <Link to="/artworks" className="btn-primary mt-12 inline-flex">Return to gallery</Link>
                    </div>
                )}
                {status.state === 'pending' && (
                    <>
                        <h1 className="serif text-5xl mt-6">Payment processing</h1>
                        <p className="mt-6" style={{ color: 'var(--ink-2)' }}>Your payment is still being processed. We will confirm by email shortly.</p>
                        <Link to="/" className="btn-ghost mt-10 inline-flex">Return home</Link>
                    </>
                )}
                {(status.state === 'expired' || status.state === 'error') && (
                    <>
                        <h1 className="serif text-5xl">Session expired</h1>
                        <Link to="/artworks" className="btn-primary mt-10 inline-flex">Back to artworks</Link>
                    </>
                )}
            </div>
        </div>
    );
}
